import React from 'react'
import { FloatingShapesBackgroundProps } from './FloatingShapesBackground.types'
import css from './FloatingShapesBackground.styles.scss'
import Clover from './components/Clover'
import Burst from './components/Burst'
import Flower from './components/Flower'

const FloatingShapesBackground: React.FC<FloatingShapesBackgroundProps> = ({
  animated = false,
  children,
}) => (
  <div className={css.FloatingShapesBackground}>
    <div className={css.FloatingShapesBackground__Background}>
      <Clover animated={animated} />
      <Burst animated={animated} />
      <Flower animated={animated} />
    </div>
    <div className={css.FloatingShapesBackground__Foreground}>{children}</div>
  </div>
)

export default FloatingShapesBackground
